import React from 'react';
import { Form, Button, Grid } from 'semantic-ui-react';
import { FormRenderProps } from 'react-final-form';
import arrayMutators from 'final-form-arrays';

import FieldValue from 'components/FieldValue';
import { VirtualizedTableItem } from 'services/virtualizedTable/types';
import QueryStringButton from 'components/QueryStringButton';

import VirtualizedTableBulkEditFormValueField from '../VirtualizedTableBulkEditFormValueField';
import VirtualizedTableBulkEditFormColumnDropdown from '../VirtualizedTableBulkEditFormColumnDropdown';
import { BULK_EDIT_MODAL_QUERY_STRING_PARAM } from '../../constants';

type Props = Partial<FormRenderProps<VirtualizedTableItem>>;

export const VirtualizedTableBulkEditFormComponent = (
    props: Props
): React.ReactElement => {
    const { handleSubmit } = props;
    return (
        <Form
            onSubmit={handleSubmit}
            mutators={{
                ...arrayMutators
            }}
        >
            <VirtualizedTableBulkEditFormColumnDropdown />
            <Grid className="no-vertical-gutters">
                <FieldValue name="columnKey">
                    <VirtualizedTableBulkEditFormValueField />
                </FieldValue>
            </Grid>
            <Grid>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                    <QueryStringButton
                        params={{
                            [BULK_EDIT_MODAL_QUERY_STRING_PARAM]: undefined
                        }}
                        buttonProps={{
                            type: 'button',
                            fluid: true,
                            basic: true,
                            primary: true
                        }}
                        ignoreActive
                    >
                        Cancel
                    </QueryStringButton>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                    <Button type="submit" primary fluid>
                        Submit
                    </Button>
                </Grid.Column>
            </Grid>
        </Form>
    );
};

export default VirtualizedTableBulkEditFormComponent;
